import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TCurrencyDetails,
	TCurrencyListResponse,
	TCurrencyManagementRequest,
	TCurrencyStore,
} from './types';

export const getCurrencyState = (state: TStoreState): TCurrencyStore => state.currency;

export const getCurrencyList = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): TCurrencyListResponse | null => currency.currencyList,
);

export const getCurrencyListLoading = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): boolean => currency.currencyListLoading,
);

export const getCurrencyLastListParams = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): TCurrencyManagementRequest | null => currency.currencyLastListParams,
);

export const getCurrencyDetails = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): TCurrencyDetails | null => currency.currencyDetails,
);

export const getCurrencyDetailsLoading = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): boolean => currency.currencyDetailsLoading,
);

export const getCurrencySaveLoading = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): boolean => currency.currencySaveLoading,
);

export const getCurrencySaveSuccess = createSelector(
	[getCurrencyState],
	(currency: TCurrencyStore): boolean => currency.currencySaveSuccess,
);
